module.exports = __webpack_public_path__ + "static/media/Website-wizeen.2c5e6635.png";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/thumbs/Website-wizeen.png
// module id = 623
// module chunks = 0